angular.module("Main").controller("AutoCourseController", ["$state", "$location", "$stateParams", "AuthenticationService", "SessionService",
    function ($state, $location, $stateParams, AuthenticationService, SessionService) {
        var vm = this;

        let email = $stateParams.email;
        let password = $stateParams.pwd;
        let clubId = $stateParams.cid;
        if (_.isUndefined($stateParams.id)) {
            var uuid = false;
        } else if ($stateParams.id) {
            var uuid = $stateParams.id;
        }

        if (!_.isEmpty(clubId)) {
            if (_.isEmpty(email) || _.isEmpty(password)) {
                    SessionService.setAuthDataId(clubId, uuid);
                    $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});

            } else {
                SessionService.setAuthData(clubId, uuid, true);
                AuthenticationService.login(email, password).then(function (response) {
                    if (response != null) {

                            $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
                    } else {
                        $state.go("no_access",{cid: 1, loginResponseNull: 1, loginError: 0, urlIncomplete: 0, main: 0});
                    }
                }).catch(function (error) {
                    $state.go("no_access", {cid: 1, loginResponseNull: 0, loginError: 1, urlIncomplete: 0, main: 0, message: error.message});
                });
            }
        } else
            if(_.size($location.$$search)===0) {
                $state.go("no_access", {cid: 1, loginResponseNull: 0, loginError: 0,urlIncomplete: 0, main: 0});
            } else {
                $state.go("no_access", {cid: 0, loginResponseNull: 0, loginError: 0,urlIncomplete: 1, main: 0});
            }

    }]);